module.exports = __webpack_public_path__ + "static/media/ios-battery-charging.2608b148.svg";